import { render, staticRenderFns } from "./PenalidadeAbaNotificacoes.vue?vue&type=template&id=2b938d4c"
import script from "./PenalidadeAbaNotificacoes.vue?vue&type=script&lang=js"
export * from "./PenalidadeAbaNotificacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports